import { useMemo } from 'react';
import { useFormValues } from '@s20/components/forms/FormContext';
import { DraggableResourceTypes } from '../../../dispatch/Dispatch';

export const useResourceQueryKey = () => {
    const {
        selectedJobId, selectedDate, selectedResourceType, filters,
        selectedResourceGroup, selectedCertifications, dispatchGroupId, replacementAssignmentId,
        replacementLinkedAssignmentIds,
    } = useFormValues();

    const selectedResourceGroupId = selectedResourceType === DraggableResourceTypes.Equipment ? selectedResourceGroup?.requiredEquipment?.[0]?.id : selectedResourceGroup?.id;
    const isRentalPickup = selectedResourceGroup?.isRentalPickup === true;

    const queryKey = useMemo(() =>
        ['dispatchResources', selectedCertifications, selectedJobId, selectedDate, selectedResourceType, filters, selectedResourceGroupId, isRentalPickup, dispatchGroupId, replacementAssignmentId, replacementLinkedAssignmentIds],
        [selectedJobId, selectedCertifications, selectedDate, selectedResourceType, filters, selectedResourceGroupId, isRentalPickup, dispatchGroupId, replacementAssignmentId, replacementLinkedAssignmentIds],
    );

    return {
        queryKey,
        selectedJobId,
        selectedDate,
        selectedResourceType,
        filters,
        selectedResourceGroupId,
        selectedCertifications,
        isRentalPickup,
        dispatchGroupId,
        replacementAssignmentId,
        replacementLinkedAssignmentIds,
    };
};